import React, { memo } from 'react';

import { Box, CircularProgress, LinearProgress, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { PREVIEW_COPY } from '../../previewGeneration.constants';
import { PreviewStepTestIds } from '../../PreviewStep.testIds';

import {
  containerStyles,
  progressStyles,
  subtitleStyles,
  titleStyles,
} from './PreviewGeneratingOverlay.styles';

const PreviewGeneratingOverlay = ({ progress }) => (
  <Box data-testid={PreviewStepTestIds.GENERATING} sx={containerStyles}>
    <CircularProgress size={34} thickness={4} />
    <Typography sx={titleStyles} variant="bold16">
      {PREVIEW_COPY.generatingTitle}
    </Typography>
    <Typography sx={subtitleStyles} variant="regular14">
      {PREVIEW_COPY.generatingSubtitle}
    </Typography>
    <LinearProgress sx={progressStyles} value={progress} variant="determinate" />
  </Box>
);

PreviewGeneratingOverlay.propTypes = {
  progress: PropTypes.number,
};

export default memo(PreviewGeneratingOverlay);
